module.exports = __webpack_public_path__ + "img/fiveHundredE.aa0f01ef.jpg";